var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import VueGtag from 'vue-gtag';
import { BRow, BCol, BButton, BFormGroup, BFormInput, BFormCheckbox, BOverlay, BAlert, BCard } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { addToCart } from 'ts/modules/cart';
import { getVatMode } from 'ts/modules/helpers';
import MountboardColours from 'components/MountboardColours.vue';
Vue.use(VueGtag, {
    config: { id: "UA-939335-4" }
});
let ColourSamples = class ColourSamples extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.addingToCart = false;
        this.selectedBoard = null;
        this.vatMode = 'inc';
        this.mountPricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.debouncedPrice = debounce(this.updatePricing, 250);
    }
    pricingPayload(sku) {
        return {
            params: {
                sku,
                quantity: 1,
            }
        };
    }
    onSelectedBoardChanged() {
        this.updatePricing();
    }
    updatePricing() {
        this.loading = true;
        axios
            .get('/api/pricing/mountboard/sample', this.pricingPayload('MSMP-' + (this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001')))
            .then(({ data }) => this.mountPricing = data)
            .finally(() => this.loading = false);
    }
    get exVatUnitPrice() {
        return this.mountPricing.ex_vat_base_unit_price;
    }
    get totalPrice() {
        return this.mountPricing.total_price;
    }
    addToCart() {
        this.addingToCart = true;
        const item = {
            sku: `MSMP-${this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'}`,
            qty: 1,
            attributes: {}
        };
        // Log the add to cart event
        this.$gtag.event('add_to_cart', {
            "items": [
                {
                    "id": item.sku,
                    "name": `${item.sku} - Sample`,
                    "brand": "Brampton Framing",
                    "category": "Mountboard Sample",
                    "quantity": 1,
                    "price": this.exVatUnitPrice
                }
            ]
        });
        addToCart(item, false)
            .then(() => this.addingToCart = false);
    }
    created() {
        this.vatMode = getVatMode();
    }
};
__decorate([
    Watch('selectedBoard')
], ColourSamples.prototype, "onSelectedBoardChanged", null);
ColourSamples = __decorate([
    Component({
        components: {
            BRow, BCol, BButton, BFormGroup, BFormInput, BFormCheckbox, BOverlay, BAlert, BCard,
            MountboardColours
        }
    })
], ColourSamples);
export default ColourSamples;
